import React, { useState, useEffect, useCallback } from 'react';
// YENİ EKLENDİ: Arama çubuğu için Form ve InputGroup
import { Button, Modal, Card, Spinner, Alert, Form, InputGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import DiyetisyenFormu from './DiyetisyenFormu';
import api from './api';

function AdminDiyetisyenler() {
  const navigate = useNavigate();
  const [diyetisyenler, setDiyetisyenler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [duzenlenenDiyetisyen, setDuzenlenenDiyetisyen] = useState(null);
  
  // YENİ EKLENDİ: Arama metnini tutmak için state
  const [aramaMetni, setAramaMetni] = useState('');

  const diyetisyenleriGetir = useCallback(async () => {
    try {
      const response = await api.get('/admin/kullanicilar');
      // Gelen kullanıcı listesini role göre filtrele
      setDiyetisyenler(response.data.filter(user => user.rol === 'diyetisyen' || user.rol === 'klinik_yoneticisi'));
    } catch (err) {
      setError("Diyetisyenler yüklenirken bir hata oluştu.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { diyetisyenleriGetir(); }, [diyetisyenleriGetir]);

  // YENİ EKLENDİ: Arama metnine göre diyetisyenleri filtrele
  const filtrelenmisDiyetisyenler = diyetisyenler.filter(diyetisyen =>
    diyetisyen.kullanici_adi.toLowerCase().includes(aramaMetni.toLowerCase()) ||
    diyetisyen.eposta.toLowerCase().includes(aramaMetni.toLowerCase()) ||
    (diyetisyen.klinik_adi && diyetisyen.klinik_adi.toLowerCase().includes(aramaMetni.toLowerCase()))
  );

  const handleFormSubmit = async (formData) => {
    const isUpdating = !!duzenlenenDiyetisyen?.id;
    const url = isUpdating ? `/admin/kullanicilar/${duzenlenenDiyetisyen.id}` : '/admin/kullanicilar';
    const method = isUpdating ? 'put' : 'post';
    try {
      await api[method](url, formData);
      setShowModal(false);
      diyetisyenleriGetir();
    } catch (err) {
      alert(`Hata: ${err.response?.data?.mesaj || 'İşlem başarısız'}`);
    }
  };
  
  const handleSil = async (diyetisyenId) => {
    if (!window.confirm('Bu kullanıcıyı silmek istediğinizden emin misiniz?')) return;
    try {
      await api.delete(`/admin/kullanicilar/${diyetisyenId}`);
      diyetisyenleriGetir();
    } catch (err) {
      alert(err.response?.data?.mesaj || 'Silme işlemi başarısız');
    }
  };

  const handleModalOpen = (diyetisyen = null) => {
    setDuzenlenenDiyetisyen(diyetisyen);
    setShowModal(true);
  };

  if (loading) return <Spinner animation="border" variant="light" />;
  if (error) return <Alert variant="danger">{error}</Alert>;

  return (
    <Card className="glass-card text-white">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <Card.Title as="h2">Diyetisyen Yönetimi</Card.Title>
          <Button variant="light" onClick={() => handleModalOpen()}>+ Yeni Diyetisyen Ekle</Button>
        </div>
        
        <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }} className="mb-3">
          Detay sayfası için bir diyetisyene tıklayın.
        </p>

        {/* YENİ EKLENDİ: Arama Çubuğu */}
        <InputGroup className="mb-3">
          <Form.Control
            placeholder="Diyetisyen adı, e-posta veya klinik adına göre ara..."
            value={aramaMetni}
            onChange={(e) => setAramaMetni(e.target.value)}
          />
        </InputGroup>

        <div style={{ overflowX: 'auto' }}>
          <table className="data-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Kullanıcı Adı</th>
                <th>Bağlı Olduğu Klinik</th>
                <th>Abonelik Sonu</th>
                <th className="text-end">İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {filtrelenmisDiyetisyenler.map(diyetisyen => (
                <tr
                  key={diyetisyen.id}
                  onClick={() => navigate(`/admin/diyetisyenler/${diyetisyen.id}`)}
                  style={{ cursor: 'pointer' }}
                  title="Detayları görüntüle"
                >
                  <td data-label="ID">{diyetisyen.id}</td>
                  <td data-label="Kullanıcı Adı" className="fw-semibold">{diyetisyen.kullanici_adi}</td>
                  <td data-label="Klinik">{diyetisyen.klinik_adi || '-'}</td>
                  <td data-label="Abonelik Sonu">{diyetisyen.abonelik_bitis_tarihi ? new Date(diyetisyen.abonelik_bitis_tarihi).toLocaleDateString('tr-TR') : '-'}</td>
                  {/* Satır tıklaması detaya gider; işlem butonları olayı yutmalı */}
                  <td data-label="İşlemler" className="text-end" onClick={(e) => e.stopPropagation()}>
                    <Button variant="warning" size="sm" onClick={() => handleModalOpen(diyetisyen)}>Düzenle</Button>
                    <Button variant="danger" size="sm" className="ms-2" onClick={() => handleSil(diyetisyen.id)}>Sil</Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card.Body>

      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{duzenlenenDiyetisyen?.id ? 'Diyetisyen Düzenle' : 'Yeni Diyetisyen Ekle'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DiyetisyenFormu 
            mevcutDiyetisyen={duzenlenenDiyetisyen}
            onFormSubmit={handleFormSubmit}
            onIptal={() => setShowModal(false)}
          />
        </Modal.Body>
      </Modal>
    </Card>
  );
}
export default AdminDiyetisyenler;